import React, { createContext, useContext, useState } from 'react';

export type WarningZone = {
    id: string;
    name: string;
    centerLat: number;
    centerLon: number;
    radius: number;
    severity: number;
    content: string;
    startTime: number;
    endTime: number;
    auto_notify: boolean;
    status: number | string;
};

type WarningZoneContextType = {
    warningZones: Record<string, WarningZone>;
    setWarningZones: React.Dispatch<React.SetStateAction<Record<string, WarningZone>>>;
};

const WarningZoneContext = createContext<WarningZoneContextType | undefined>(undefined);

export const WarningZoneProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [warningZones, setWarningZones] = useState<Record<string, WarningZone>>({
        "zone_001": {
            "name": "Vùng nguy hiểm 1",
            "id": "zone_001",
            "centerLat": 11,
            "centerLon": 111,
            "radius": 150000,
            "severity": 1,
            "content": "Khu vực nguy hiểm mức độ 1.",
            "startTime": 1748739600000,
            "endTime": 1780275600000,
            "auto_notify": true,
            "status": 1,
        }
    });

    return (
        <WarningZoneContext.Provider value={{ warningZones, setWarningZones }}>
            {children}
        </WarningZoneContext.Provider>
    );
};

export const useWarningZoneContext = () => {
    const context = useContext(WarningZoneContext);
    if (!context) throw new Error('useWarningZoneContext must be used within WarningZoneProvider');
    return context;
};